import React, { useEffect, useState } from "react";
import {
  getCurrentFY,
  getDaysInFYMonths,
  months,
  sumArrayOfObjects,
} from "../../../../Utilitie";
import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import HalfDoughnutChart from "../../../../CHARTS/HalfDoughnutChart";
const DispatchChart = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [chartData2, setChartData2] = useState(null);
  const product = ["Sick Marking Per Rakes", "Sick Marking Per Day"];
  let years = [...new Set(data.map((o) => o.F_YEAR))];
  years.sort((a, b) => a.replace("-", "") - b.replace("-", ""));
  const [selectedYear, setSelectedYear] = useState(
    getCurrentFY().replace("_", "-"),
  );
  useEffect(() => {
    let tempChart = {
      dimensions: ["product", ...years],
      series: [],
    };

    // tempChart = { ...tempChart, dimensions: ["product", ...years] };
    product.map((p) => {
      let obj = { product: p };

      years.forEach((year) => {
        let tempMonths = [
          ...new Set(
            data
              .filter((o) => o.F_YEAR === year)
              .map((o) => o.MONTH.toUpperCase().slice(0, 3)),
          ),
        ];
        let month = tempMonths.sort(
          (a, b) => months.indexOf(a) - months.indexOf(b),
        );

        let days = tempMonths
          ? getDaysInFYMonths(year.replace("-", "_"), month)
          : 1;
        let totalRakes = data
          .filter((d) => d.F_YEAR === year)
          .reduce((sum, temp) => {
            return sum + temp.TOTAL_RAKES;
          }, 0);
        const total = data.reduce((sum, o) => {
          if (o.F_YEAR === year) {
            return (
              sum +
                o.SICK_MR_SER_TOTAL /
                  (p === "Sick Marking Per Day" ? days : totalRakes) || 0
            ); // safely add
          }
          return sum; // must return sum if condition fails
        }, 0);

        obj[year] = total.toFixed(1);
      });

      tempChart.series.push(obj);
    });

    setChartData(tempChart);
  }, [data]);

  useEffect(() => {
    if (data && selectedYear) {
      let dataToSum = data.filter((d) => d.F_YEAR === selectedYear);

      let sum = sumArrayOfObjects(dataToSum, [], [], "");
      const names = [
        "SM_NPOH",
        "SM_POH_inc_B_Van",
        "SM_Gap_or_Position_Change",
        "SM_ROH",
        "SICK_MR_SER_INTER_MIX",
      ];
      let tempChartData = [];
      names.map((name) => {
        if (name === "SICK_MR_SER_INTER_MIX") {
          tempChartData.push({
            name: "Segregation",
            value: sum[0]?.[name] / dataToSum.length,
          });
        } else {
          tempChartData.push({
            name: name.replace("SM_", "").replace("or Po", "or\nPo"),
            value: sum[0]?.[name],
          });
        }
      });
      setChartData2(tempChartData);
    }
  }, [data, selectedYear]);

  return (
    <div>
      <div className="row">
        <h5 className="text-start">Dispatch</h5>
        <hr />
        <div className="col-md-6 border-end ">
          <h5>
            Received and Dispatched Trains
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(per day)</b>
          </h5>
        </div>
        <div className="col-md-6 ">
          <h5>
            BOXN Dispatched
            <b style={{ fontSize: "13px", color: "#7e7d7dff" }}>(per day)</b>
          </h5>
          {/* {chartData && (
            <GroupedBarChart
              data={chartData}
              rotateText={0}
              from={`Block_C`}
              chartType="bar"
              height={300}
            />
          )}{" "} */}
        </div>
      </div>
    </div>
  );
};
export default DispatchChart;
